import React, { useState } from 'react';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('Thank you for your message! We will get back to you soon.');
        setFormData({
            name: '',
            email: '',
            phone: '',
            message: ''
        });
    };

    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        const email = e.target.querySelector('input[type="email"]').value;
        if (email) {
            alert('Thank you for subscribing to our newsletter!');
            e.target.querySelector('input[type="email"]').value = '';
        }
    };

    return (
        <section id="contact" className="contact">
            <div className="container">
                <div className="section-header">
                    <h2>Get In Touch</h2>
                    <p>We'd love to hear from you. Contact us today!</p>
                </div>
                <div className="contact-content">
                    <div className="contact-info">
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>
                            <div className="info-text">
                                <h3>Address</h3>
                                <p>Opus Tower<br />Business Bay, Dubai, UAE</p>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-phone"></i>
                            </div>
                            <div className="info-text">
                                <h3>Phone</h3>
                                <p>
                                    <a href="tel:+971585110336" style={{ color: 'inherit', textDecoration: 'none' }}>+971 58 511 0336</a><br />
                                    <a href="tel:+971558352452" style={{ color: 'inherit', textDecoration: 'none' }}>+971 55 835 2452</a>
                                </p>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-envelope"></i>
                            </div>
                            <div className="info-text">
                                <h3>Email</h3>
                                <p>
                                    <a href="mailto:mansoorsuhaib983@yahoo.com" style={{ color: 'inherit', textDecoration: 'none' }}>mansoorsuhaib983@yahoo.com</a>
                                </p>
                            </div>
                        </div>
                        <div className="info-item">
                            <div className="info-icon">
                                <i className="fas fa-clock"></i>
                            </div>
                            <div className="info-text">
                                <h3>Working Hours</h3>
                                <p>Monday - Friday: 9:00 AM - 9:00 PM<br />Saturday - Sunday: 1:00 PM - 9:00 PM</p>
                            </div>
                        </div>
                    </div>
                    <div className="contact-form">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input 
                                    type="text" 
                                    name="name"
                                    placeholder="Your Name" 
                                    value={formData.name}
                                    onChange={handleChange}
                                    required 
                                />
                            </div>
                            <div className="form-group">
                                <input 
                                    type="email" 
                                    name="email"
                                    placeholder="Your Email" 
                                    value={formData.email}
                                    onChange={handleChange}
                                    required 
                                />
                            </div>
                            <div className="form-group">
                                <input 
                                    type="tel" 
                                    name="phone"
                                    placeholder="Your Phone" 
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <textarea 
                                    name="message"
                                    placeholder="Your Message" 
                                    rows="5" 
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>
                            <button type="submit" className="submit-btn">Send Message</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
